import { Injectable } from '@angular/core';

@Injectable()
export class KltTimezoneService {
  getUserTimezone(): string {
    return Intl.DateTimeFormat().resolvedOptions().timeZone;
  }
}
